import actions from './coordiActions';
import mutations from './coordiMutations';
import state from './coordiState';
import getters from './coordiGetters';

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}